/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */
import { OpaqueToken } from '@angular/core';
/**
 * Used to provide a {@link ControlValueAccessor} for form controls.
 *
 * See {@link DefaultValueAccessor} for how to implement one.
 * @stable
 */
export var /** @type {?} */ NG_VALUE_ACCESSOR = new OpaqueToken('NgValueAccessor');
//# sourceMappingURL=control_value_accessor.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@angular/forms/src/directives/control_value_accessor.js
// module id = 43
// module chunks = 4